/* eslint-disable @typescript-eslint/camelcase */
import * as R from 'ramda';

import { GetRecentSalesResponse } from './APITemplateEngine';
import { LegacyRecentSaleResponse } from './types';

const saleFields = ['sales_document_number', 'date_time'] as const;
const rowFields = ['product_name', 'code', 'amount', 'row_net_total'] as const;

export type RecentSale = Pick<
  LegacyRecentSaleResponse,
  typeof saleFields[number]
> & {
  rows: Pick<LegacyRecentSaleResponse, typeof rowFields[number]>[];
};

export function mapLegacyRecentSales(
  sales: Record<string, LegacyRecentSaleResponse>,
): RecentSale[] {
  const saleList = Object.entries(sales)
    .map(([_, value]) => value)
    .flatMap(a => a);
  return R.pipe(
    // Sort by row id
    R.sort<LegacyRecentSaleResponse>(R.ascend(R.prop('row_id'))),
    // Group by document_id
    R.groupBy(R.prop('sales_document_number')),
    // Merge into one sales doc with multiple rows
    R.map(
      sale =>
        (R.assoc(
          'rows',
          R.map(
            R.pick<LegacyRecentSaleResponse, keyof LegacyRecentSaleResponse>(
              rowFields,
            ),
          )(sale),
          R.pick(saleFields)(sale[0]),
        ) as any) as RecentSale,
    ),
    // Ungroup
    R.values,
  )(saleList);
}

export function sortSalesHistory(sales: RecentSale[]): RecentSale[] {
  return R.sort(R.descend(R.prop('date_time')))(sales);
}

export function mapRecentSales(
  sales: GetRecentSalesResponse['data'],
): RecentSale[] {
  return Object.values(sales).map(
    (saleRow): RecentSale => ({
      date_time: saleRow[0].date_time,
      sales_document_number: saleRow[0].sales_document_number,
      rows: saleRow.map(sale => ({
        code: sale.code,
        product_name: sale.product_name,
        amount: String(sale.amount),
        row_net_total: String(sale.row_net_total),
      })),
    }),
  );
}
